import axios from 'axios';

import { webSocketApiUrlsDictionary } from '../constants';

type Headers = {
  Authorization?: string;
  Platform: string;
};

const theme = localStorage.getItem('theme');

const defaultUrl =
  webSocketApiUrlsDictionary[theme]?.gatewayUrl ||
  process.env.REACT_APP_API_GATEWAY_URL;

const BASE_URL = `${defaultUrl}/mk-ms-risk-analysis`;

const defaultHeaders: Headers = {
  Platform: 'DASHBOARD',
};

const token = localStorage.getItem('auth-token');

if (token) {
  defaultHeaders.Authorization = `Bearer ${token}`;
}

export const api = axios.create({
  baseURL: BASE_URL,
  headers: { ...defaultHeaders },
});

export type RiskLevel = 'HIGH' | 'MEDIUM' | 'LOW';

export type ClearSaleScore = {
  score: number;
  riskLevel: RiskLevel;
  transactionUuid: string;
  createdAt: string;
};

export const getClearSaleScore = async (
  document?: string | null,
  documentType?: string | null,
): Promise<ClearSaleScore | null> => {
  const digits = (document || '').replace(/\D/g, '');

  if (!digits) {
    return null;
  }

  try {
    const response = await api.get('/clear-sale-score', {
      params: { document: digits, documentType: documentType || undefined },
    });

    if (response.status === 204 || !response.data) {
      return null;
    }

    return response.data as ClearSaleScore;
  } catch (error) {
    return null;
  }
};

export const getClearSaleCardScore = async (
  document?: string | null,
  documentType?: string | null,
): Promise<ClearSaleScore | null> => {
  const digits = (document || '').replace(/\D/g, '');

  if (!digits) {
    return null;
  }

  try {
    const response = await api.get('/clear-sale-score/card', {
      params: { document: digits, documentType: documentType || undefined },
    });

    if (response.status === 204 || !response.data) {
      return null;
    }

    return response.data as ClearSaleScore;
  } catch (error) {
    return null;
  }
};
